import React from 'react'

const Home = () => {
    return (
        <div>
            hello
        </div>
    )
}

export default Home
